import getMessages from '../../backend/messagebannerRequests';
import { gaActions } from '../gaActionTypes';

// Consts
export const FETCH_MESSAGE_BANNERS_SUCCESS = `[MESSAGE BANNERS] FETCH SUCCESS`;
export const PUSH_MESSAGE_BANNERS_SUCCESS = `[MESSAGE BANNERS] PUSH SUCCESS`;
export const FETCH_MESSAGE_BANNERS_ERROR = `[MESSAGE BANNERS] FETCH ERROR`;
export const DISMISS_MESSAGE_BANNER = `[MESSAGE BANNERS] DISMISS`;
export const CLEAR_MESSAGE_BANNER = `[MESSAGE BANNERS] ${gaActions.global} Clear Message Banner`;
export const CLEAR_MESSAGE_BANNERS = `[MESSAGE BANNERS] ${gaActions.global} Clear Message Banners`;
export const CLEAR_ALL_MESSAGES_BY_AUTHOR = `[MESSAGE BANNERS] ${gaActions.global} Clear All Messages By Author`;

export const AUTHOR_TYPES = {
  USER: 'USER',
  SYSTEM: 'SYSTEM',
  ACTION_RESULT: 'ACTION_RESULT',
};

export function fetchMessageBanners() {
  return async function(dispatch) {
    try {
      const {
        body: { data },
      } = await dispatch(getMessages);
      dispatch({
        type: FETCH_MESSAGE_BANNERS_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: FETCH_MESSAGE_BANNERS_ERROR,
        payload: err,
      });
    }
  };
}

export function pushMessageBanner(message) {
  return async function(dispatch) {
    dispatch({
      type: PUSH_MESSAGE_BANNERS_SUCCESS,
      payload: message,
    });
  };
}

export function dismissMessageBanner(messageId) {
  return {
    type: DISMISS_MESSAGE_BANNER,
    payload: messageId,
  };
}

export function setAutoDismissMessageBannerTimer(messageIdTime) {
  setTimeout(() => {
    const banner = document.getElementById(`meesage-banner-${messageIdTime}`);
    if (banner) {
      banner.click();
    }
  }, 60000);
}

export const clearMessageBanner = messageId => (dispatch, getState) => {
  const state = getState();
  const { messageBanner } = state;
  return messageBanner
    ? dispatch({ type: CLEAR_MESSAGE_BANNERS, payload: messageId })
    : null;
};

export const clearAllMessageBanners = () => (dispatch, getState) => {
  const state = getState();
  const { messageBanner } = state;
  const messages = messageBanner.messages;
  return messages.length ? dispatch({ type: CLEAR_MESSAGE_BANNERS }) : null;
};

export const clearAllMessagesByAuthor = author => (dispatch, getState) => {
  const state = getState();
  const { messageBanner } = state;
  if (messageBanner) {
    const filteredMessages = messageBanner.messages.filter(
      message => message.author !== author
    );
    dispatch({
      type: CLEAR_ALL_MESSAGES_BY_AUTHOR,
      payload: filteredMessages,
    });
  }
};
